export const RESEARCH_SUPPORT_BASE = '/research-support';

export const SUBMISSION_STATUSES = {
  DRAFT: 'draft',
  SUBMITTED: 'Submitted',
  UNDER_REVIEW: 'Under Review',
  REVISION_REQUESTED: 'Revision Requested',
  ACCEPTED: 'Accepted',
  PUBLICATION_PREP: 'Publication Preparation',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected',
};

export const STATUS_LABELS = {
  [SUBMISSION_STATUSES.DRAFT]: 'Draft',
  [SUBMISSION_STATUSES.SUBMITTED]: 'Submitted',
  [SUBMISSION_STATUSES.UNDER_REVIEW]: 'Under Review',
  [SUBMISSION_STATUSES.REVISION_REQUESTED]: 'Revision Requested',
  [SUBMISSION_STATUSES.ACCEPTED]: 'Accepted',
  [SUBMISSION_STATUSES.PUBLICATION_PREP]: 'Publication Preparation',
  [SUBMISSION_STATUSES.COMPLETED]: 'Completed',
  [SUBMISSION_STATUSES.REJECTED]: 'Rejected',
};

export const STATUS_COLORS = {
  [SUBMISSION_STATUSES.DRAFT]: 'bg-gray-100 text-gray-800',
  [SUBMISSION_STATUSES.SUBMITTED]: 'bg-blue-100 text-blue-800',
  [SUBMISSION_STATUSES.UNDER_REVIEW]: 'bg-amber-100 text-amber-800',
  [SUBMISSION_STATUSES.REVISION_REQUESTED]: 'bg-orange-100 text-orange-800',
  [SUBMISSION_STATUSES.ACCEPTED]: 'bg-green-100 text-green-800',
  [SUBMISSION_STATUSES.PUBLICATION_PREP]: 'bg-purple-100 text-purple-800',
  [SUBMISSION_STATUSES.COMPLETED]: 'bg-iof/10 text-iof-dark',
  [SUBMISSION_STATUSES.REJECTED]: 'bg-red-100 text-red-800',
};

export const STUDY_LEVELS = [
  '100 Level',
  '200 Level',
  '300 Level',
  '400 Level',
  'Final Year',
  'Recent Graduate (within 2 years)',
  'Other',
];

export const PUBLICATION_GOALS = [
  'Peer-reviewed journal',
  'Conference proceedings',
  'Institutional repository',
  'Preprint / open access',
  'Guidance only — not sure yet',
];

export const RESEARCH_FIELDS = [
  'Education',
  'Social Sciences',
  'STEM',
  'Health Sciences',
  'Arts & Humanities',
  'Business & Economics',
  'Environmental Studies',
  'Interdisciplinary',
  'Other',
];

export const NAV_LINKS = [
  { path: RESEARCH_SUPPORT_BASE, label: 'Overview', end: true },
  { path: `${RESEARCH_SUPPORT_BASE}/apply`, label: 'Application Portal' },
  { path: `${RESEARCH_SUPPORT_BASE}/guidelines`, label: 'Submission Guidelines' },
  { path: `${RESEARCH_SUPPORT_BASE}/faq`, label: 'FAQ' },
  { path: `${RESEARCH_SUPPORT_BASE}/reviewers`, label: 'Reviewers & Mentors' },
  { path: `${RESEARCH_SUPPORT_BASE}/contact`, label: 'Contact Support' },
];

export const INITIAL_FORM_STATE = {
  fullName: '',
  email: '',
  phone: '',
  institution: '',
  department: '',
  levelOfStudy: '',
  country: '',
  graduationYear: '',
  researchTitle: '',
  researchField: '',
  abstract: '',
  keywords: '',
  publicationGoal: '',
  linkedIn: '',
  files: {
    thesisPdf: null,
    supportingDocs: null,
    dataset: null,
  },
};

export const FORM_STEPS = [
  { id: 'personal', title: 'Personal & Academic' },
  { id: 'research', title: 'Research Details' },
  { id: 'documents', title: 'Documents' },
  { id: 'review', title: 'Review & Submit' },
];

export const SEO_DEFAULTS = {
  title: 'Undergraduate Research Publication Support | Intellectual Oasis Fellowship',
  description:
    'Submit your undergraduate thesis or research project for publication support, mentorship, and editorial guidance through the Intellectual Oasis Fellowship Research Support Initiative.',
  keywords:
    'undergraduate research publication, thesis publication support, student research mentorship, publication assistance for students, Intellectual Oasis Fellowship research support',
};
